import { Component, h, Host, Prop } from '@stencil/core';

export interface CustomerInfo {
  realEstateAddress: string;
  reciever: string;
  emailAddress: string;
}

@Component({
  tag: 'customer-overview-component',
  styleUrl: 'customer-overview-component.scss',
  shadow: true,
})
export class CustomerOverviewComponent {
  @Prop() customerInfo: CustomerInfo;
  render() {
    return (
      <Host>
        <div class="customer-overview">
          <div class="item">Immobilie</div>
          <div class="item">{this.customerInfo.realEstateAddress}</div>
          <div class="item">Empfänger</div>
          <div class="item">{this.customerInfo.reciever}</div>
          <div class="item">E-Mail-Adresse</div>
          <div class="item">{this.customerInfo.emailAddress}</div>
        </div>
      </Host>
    );
  }
}
